import {_, React, observer, classNames} from '@api'
import {ToolbarChip} from './'
import {site, useCatalog} from '@stores'
import * as css from './FilterChips.css'

export const SiteSearchFilterChip = observer(function SiteSearchFilterChip() {
  const {strings, catalogItemName, searcher, settings: {activeSearchText}} = useCatalog()

  if (!searcher) return null

  return _.isEmpty(activeSearchText) ? null : (
    <div className={css.filterChipsRow} data-type='searchText'>
      <ToolbarChip title={`${_.capitalize(catalogItemName)} ${strings.search}`} value={`'${activeSearchText}'`} onDelete={searcher.clearSearch}/>
    </div>)
})


export const FilterChipsSection = observer<{className?: string}>(function FilterChipsSection(props) {
  return <div {...props} className={classNames(css.filterChipsRow, props.className)} />
})




// WEBPACK FOOTER //
// ./src/modules/catalog/FilterChipsToolbar/chips/FilterChips.tsx